<template>
  <div class="conversion">
    <!-- 账户信息 -->
    <div class="account">
      <div class="account-item">
        <p>{{ brokerage_price || "0.00" }}</p>
        <p>{{ title }}</p>
      </div>
    </div>

    <!-- 转账 -->
    <div class="transfer">
      <div class="transfer-box">
        <div class="transfer-item">
          <p>接收人ID：</p>
          <input type="text" placeholder="请输入接收人ID" v-model="zr_uid" />
        </div>
        <div class="transfer-item">
          <p>转出{{ title }}：</p>
          <input
            type="text"
            :placeholder="'请输入转出' + title"
            v-model="num"
          />
        </div>
      </div>
    </div>

    <!-- 确认 -->
    <button @click="affirm">确认转账</button>
  </div>
</template>

<script>
let that;
import { getUser, transfer } from "@api/user";
export default {
  name: "conversion",
  data() {
    return {
      brokerage_price: "",
      phone: "",
      key: "",
      isType: 0,
      name: "",
      zr_uid: "",
      captcha: "",
      num: "",
      nickname: "",
      pwd: "",
      title: "积分",
      now_money: ""
    };
  },
  watch: {
    $route() {
      this.zr_uid = "";
      this.num = "";
      this.onInfo();
    }
  },
  created() {
    that = this;
    this.onInfo();
  },
  methods: {
    onInfo() {
      let query = this.$route.query;
      let isType = query.isType;
      that.isType = isType || 0;
      that.title = isType == 1 ? "余额" : isType == 2 ? "股权" : "积分";
      that.initData();
    },
    initData() {
      getUser().then(res => {
        let data = res.data;
        let isType = that.isType;
        that.brokerage_price =
          isType == 1
            ? data.now_money
            : isType == 2
            ? data.guquan
            : data.integral;
        that.now_money = data.now_money;
        that.phone = data.phone;
      });
    },
    // 核心修复：添加 affirm 方法定义，解决 _wrapper 报错
    affirm() {
      let { zr_uid, num, isType } = this;
      if (!zr_uid) {
        that.$dialog.toast({
          mes: "请输入接收人ID!"
        });
        return;
      }
      if (!num || isNaN(Number(num)) || Number(num) <= 0) {
        that.$dialog.toast({
          mes: `请输入有效的转出${this.title}数量`
        });
        return;
      }
      let data = {
        zr_uid,
        num,
        type: isType == 1 ? "now_money" : isType == 2 ? "guquan" : "integral"
      };
      transfer(data)
        .then(res => {
          that.$dialog.toast({
            mes: res.msg
          });
          let time = setTimeout(() => {
            that.$router.go(-1);
            clearTimeout(time);
          }, 800);
        })
        .catch(err => {
          that.$dialog.error(err.msg);
        });
    }
  }
};
</script>

<style lang="scss" scoped>
button {
  height: 40px;
  line-height: 40px;
  text-align: center;
  background-color: #eb5c20;
  color: #fff;
  margin: 0 auto;
  font-size: 15px;
  width: 90%;
  border-radius: 50px;
  margin: 5%;
  border: none; /* 补充：移除按钮默认边框 */
  cursor: pointer; /* 补充：鼠标悬浮显示手型 */
}

.account {
  background-color: #eb5c20;
  padding: 15px;
  display: flex;
  justify-content: space-between;
  align-items: center;

  .account-item {
    flex: 1;
    text-align: center;
    color: #fff;
    font-size: 13px;

    // 修复：将 text:first-child 改为 p:first-child（对应模板中的 p 标签）
    p:first-child {
      display: block;
      font-size: 26px;
      font-weight: bold;
    }
  }
}

.transfer {
  // 修复：将 50rpx 改为 25px（rpx 是小程序单位，网页端不支持）
  margin: 0 0 25px;

  .transfer-box {
    background-color: #fff;
    padding: 10px;
    border-radius: 5px;
    box-shadow: 0 0 5px rgba(0, 0, 0, 0.1); /* 补充：增加阴影，提升视觉效果 */

    .transfer-item {
      display: flex;
      align-items: center;
      font-size: 13px;
      color: #333;
      line-height: 3;

      // 修复：将 text 改为 p（对应模板中的 p 标签）
      p {
        flex-shrink: 0;
        display: block;
        text-align: right;
        margin-right: 15px;
      }

      input {
        flex: 1;
        height: 25px;
        line-height: 25px;
        font-size: 13px;
        // border: 1px solid #eee; /* 补充：添加输入框边框，提升辨识度 */
        border-radius: 3px;
        padding: 0 5px;
        outline: none; /* 补充：移除输入框聚焦默认轮廓 */
      }

      .sendCode {
        padding: 0 8px;
        margin-left: 30px;
        // 修复：将 50upx 改为 25px
        height: 25px;
        background-color: #eb5c20;
        border-radius: 15px;
        color: #fff;
        line-height: 25px;
        text-align: center;
        font-size: 12px;
        display: inline-block; /* 补充：让行内元素支持宽高 */

        &.on {
          background-color: #bbb;
        }
      }

      .code {
        width: 50%;
        color: #eb5c20;
        text-align: center;
      }
    }
  }
}
</style>
